module.exports = __webpack_public_path__ + "static/suburban-98dd9ff795249b9973aee98fccaf07fb.jpg";